import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {ReactNode} from 'react';
import {sx} from './sx'

interface IProps {
    icon?: ReactNode,
    label: string,
    value: string | number

}

const ItemPointInfoUiSingleVoyage = ({label, icon, value}: IProps) => {
    return (
        <>
            <Grid
                item
                xs={6}
            >
                <Typography
                    sx={sx.label}
                >
                    {icon}

                    {label}
                </Typography>
            </Grid>

            <Grid
                item
                xs={6}
            >
                <Typography
                    sx={sx.value}
                >
                    {value}
                </Typography>
            </Grid>
        </>
    );
};

export default ItemPointInfoUiSingleVoyage;